import React from 'react';
import { Card, Tab, Tabs, Form, Row, Button, Table, InputGroup, FormControl} from "react-bootstrap";
import '../App.css';
import { useHistory } from 'react-router-dom';
import MaterialTable from "material-table";
import StatsWid from './Charts/StatsWidget';
import MapWidget from './Charts/MapWidget';
import { Chip } from '@material-ui/core';
import LiveData from './LiveData';



function Detector() {
    const url = "/api";
    const token = localStorage.getItem('token');
    const detectorSelected = localStorage.getItem("detSelected");
    const [detectorID, setDetectorId] = React.useState(detectorSelected !== "" ? detectorSelected : "");
    const [detectorBtnClass, setDetectorBtnClass] = React.useState("primary");
    const [detectorData, setDetectorData] = React.useState({});
    const [tunnelPortCreated, setTunnelPortCreated] = React.useState('');
    const [lastMessage, setLastMessage] = React.useState('');
    const [changedAlias, setChangedAlias] = React.useState('');
    const [active, setActive] = React.useState('');
    const history = useHistory();
    const [loading, setLoading] = React.useState('hidden');
    const [tempStats, setTempStats] = React.useState([]);
    const [cpuStats, setCpuStats] = React.useState([]);
    const [memStats, setMemStats] = React.useState([]);
    const [diskStats, setDiskStats] = React.useState([]);
    const [responseStats, setResponseStats] = React.useState([]);
    const [newNote, setNewNote] = React.useState('');
    const [noteList, setNoteList] = React.useState([]);
    const [newSub, setNewSub] = React.useState('');
    const [autotestValue, setAutotestValue] = React.useState(false);
    const [subList, setSubList] = React.useState([]);
    const [timeScale, setTimeScale] = React.useState("2 Hours");
    const [detectorPosition, setDetectorPosition] = React.useState({
        "lat": 0,
        "lon": 0
    });
    const [servicesData, setServicesData] = React.useState([]);
    const [networkData, setNetworkData] = React.useState([]);
    const [relaysData, setRelaysData] = React.useState([]);
    const [logsData, setLogsData] = React.useState([]);
    const [cpuTemp, setCpuTemp] = React.useState({
        "title": "CPU Temperature",
        "subtitle": "Current temperature of the CPU",
        "actualValue": 0,
        "variant": "success"
    });
    const [cpu, setCpu] = React.useState({
        "title": "CPU Usage",
        "subtitle": "Current percentage of the CPU used",
        "actualValue": 0,
        "variant": "success"
    });

    const [memUsed, setMemUsed] = React.useState({
        "title": "Memory Usage",
        "subtitle": "Current percentage of the Memory used",
        "actualValue": 0,
        "variant": "success"
    });

    const [diskUsed, setDiskUsed] = React.useState({
        "title": "Disk Usage",
        "subtitle": "Current percentage of the Disk used",
        "actualValue": 0,
        "variant": "success"
    });

    const [threshold, setThreshold] = React.useState({
        "cpuTempTh": 0,
        "cpuTh": 0,
        "memTh": 0,
        "diskTh": 0,
        "responseTimeTh": 0
    });

    const [selectedFileSys, setSelectedFileSys] = React.useState();
    const [isFilePickedSys, setIsFilePickedSys] = React.useState(false);
    const [selectedFileFs, setSelectedFileFs] = React.useState();
    const [isFilePickedFs, setIsFilePickedFs] = React.useState(false);
    const [selOs, setSelOs] = React.useState("");
    const [firmwareList, setFirmwareList] = React.useState([]);

    const months = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
    ];
    const days = [
        'Domingo',
        'Lunes',
        'Martes',
        'Miércoles',
        'Jueves',
        'Viernes',
        'Sábado'
    ];

    const servicesColumns = [
        {
            title: "Name",
            field: "name",
            align: 'center',
        },
        {
            title: "Enabled",
            field: "enabled",
            align: 'center',
        },
        {
            title: "Active",
            field: "active",
            align: 'center',
        },
        {
            title: "Service Type",
            field: "type",
            align: 'center'
        },
        {
            title: "Status",
            field: "status",
            align: 'center'
        }
    ];

    const networkColumns = [
        {
            title: "Name",
            field: "name",
            align: 'center',
        },
        {
            title: "Type",
            field: "type",
            align: 'center',
        },
        {
            title: "Addresses",
            field: "addr",
            align: 'center'
        },
        {
            title: "MAC",
            field: "mac",
            align: 'center'
        }
    ];

    const relaysColumns = [
        {
            title: "Alias",
            field: "alias",
            align: 'center',
        },
        {
            title: "Input/Ouput",
            field: 'inout',
            align: 'center'
        },
        {
            title: "Active",
            field: "active",
            align: 'center',
        },
        {
            title: "Enabled",
            field: "enabled",
            align: 'center'
        }
    ];

    const logsColumns = [
        {
            title: "Date and time",
            field: "datetime",
            align: 'center'
        },
        {
            title: "Level",
            field: "level",
            align: 'center',
            render: datos => <Chip label={datos.level} style={{ color: "white", backgroundColor: datos.level === "INFO" ? "#076129" : datos.level === "WARNING" ? "#c66f27" : "#be0000" }} ></Chip>
        },
        {
            title: "Category",
            field: "category",
            align: 'center',
        },
        {
            title: "User",
            field: "user",
            align: 'center'
        },

        {
            title: "Message",
            field: "message",
            align: 'center'
        }
    ];

    const notesColumns = [
        {
            title: "User",
            field: "user",
            align: 'center'
        },
        {
            title: "Note",
            field: "message",
            align: 'center',
        },
        {
            title: "Date and time",
            field: "dateTime",
            align: 'center'
        }
    ]

    const subColumns = [
        {
            title: "Subscriptor Email",
            field: "email",
            align: "center"
        }
    ]

    const firmwareColumns = [
        {
            title: "Hardware",
            field: "hardware",
            align: "center"
        },
        {
            title: "Version",
            field: "version",
            align: "center"
        }
    ]

    async function getLogs() {
        let options = {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            }
        }
        var logsRows = [];
        let logResponse = await fetch(url + '/logList/' + detectorID, options).catch(err => {
            console.log(err);
        });
        if (logResponse.status !== 200) {
            if (logResponse.status === 401) {
                localStorage.removeItem('token')
            }
            console.log("Can't get the log list");
        }
        var logDataReceived = await logResponse.json();
        if (logDataReceived.length > 0) {
            logDataReceived.forEach(log => {
                const monthsLog = [
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    '10',
                    '11',
                    '12'
                ];
                const dateLast = new Date(log.dateTime);
                const hours = (0 + dateLast.getHours().toString()).slice(-2);
                const minutes = (0 + dateLast.getMinutes().toString()).slice(-2);
                const seconds = (0 + dateLast.getSeconds().toString()).slice(-2);
                const monthName = monthsLog[dateLast.getMonth()];
                const formattedHora = `${hours}:${minutes}:${seconds}`;
                var logMessage = dateLast.getDate() + '/' + monthName + '/' + dateLast.getFullYear() + ' at  ' + formattedHora;
                const message = log.message === "" ? "---" : log.message;
                logsRows.push({
                    alias: log.alias ? log.alias : "---",
                    level: log.level,
                    category: log.category,
                    user: log.user === "" ? "---" : log.user,
                    message: message,
                    datetime: logMessage
                });
            });
            logsRows.reverse()
            setLogsData(logsRows);
        }
    }

    async function computeDetectorsInformation() {
        let options = {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            }
        }
        let responseTh = await fetch(url + '/threshold/' + detectorID, options).catch(err => {
            console.log(err);
        });
        if (responseTh.status !== 200) {
            if (responseTh.status === 401) {
                localStorage.removeItem('token');
            }
            console.log("Can't get the threshold information");
        }
        var thDataReceived = await responseTh.json();
        await setThreshold({
            cpuTempTh: thDataReceived.cpuTempTh,
            cpuTh: thDataReceived.cpuTh,
            memTh: thDataReceived.memTh,
            diskTh: thDataReceived.diskTh,
            responseTimeTh: thDataReceived.responseTimeTh
        });

        if (detectorID !== "" && detectorID !== null) {
            var servicesRows = [];
            var networkRows = [];
            var relaysRows = [];
            var detectorNotes = [];
            var detectorSubs = [];
            let responseNotes = await fetch(url + '/notes/' + detectorID, options).catch(err => {
                console.log(err);
            });
            if (responseNotes.status !== 200) {
                console.log("Can't get the notes information");
            }

            let responseSubs = await fetch(url + '/subscriptor/' + detectorID, options).catch(err => {
                console.log(err);
            });
            if (responseSubs.status !== 200) {
                console.log("Can't get the subscriptors information");
            }


            var notesReceived = await responseNotes.json();
            notesReceived.forEach(note => {
                const monthsNote = [
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    '10',
                    '11',
                    '12'
                ];
                const dateLast = new Date(note.dateTime);
                const hours = (0 + dateLast.getHours().toString()).slice(-2);
                const minutes = (0 + dateLast.getMinutes().toString()).slice(-2);
                const seconds = (0 + dateLast.getSeconds().toString()).slice(-2);
                const monthName = monthsNote[dateLast.getMonth()];
                const formattedHora = `${hours}:${minutes}:${seconds}`;
                var noteDate = dateLast.getDate() + '/' + monthName + '/' + dateLast.getFullYear() + ' at  ' + formattedHora;
                detectorNotes.push({
                    id: note._id,
                    user: note.user,
                    message: note.note,
                    dateTime: noteDate
                })
            });

            await setNoteList(detectorNotes);

            var subsReceived = await responseSubs.json();
            subsReceived.forEach(sub => {
                detectorSubs.push({
                    email: sub
                });
            });

            await setSubList(detectorSubs);

            let response = await fetch(url + '/detector/' + detectorID, options).catch(err => {
                console.log(err);
            });
            if (response.status !== 200) {
                console.log("Can't get the detector information");
            }
            var dataReceived = await response.json();
            //console.log(dataReceived);
            setDetectorData(dataReceived);

            setDetectorPosition({
                lat: dataReceived.location.lat,
                lon: dataReceived.location.lon
            });

            setAutotestValue(dataReceived.autotest);

            if (dataReceived.system !== undefined && dataReceived.system.timeValues.length > 2) {
                const scale = localStorage.getItem("timeScale");
                if (scale === '2 Hours' || scale === '') {
                    const dateLast = new Date(dataReceived.system.timeValues[dataReceived.system.timeValues.length - 1]);
                    const dateNow = new Date();
                    const monthName = months[dateLast.getMonth()];
                    const dayName = days[dateLast.getDay()];
                    const year = dateLast.getFullYear();
                    const dayNum = dateLast.getDate();
                    const hours = (0 + dateLast.getHours().toString()).slice(-2);
                    const minutes = (0 + dateLast.getMinutes().toString()).slice(-2);
                    const seconds = (0 + dateLast.getSeconds().toString()).slice(-2);
                    const formattedFecha = `${dayName}, ${dayNum} ${monthName} ${year}`;
                    const formattedHora = `${hours}:${minutes}:${seconds}`;
                    var lastMessage = "";
                    if (dayName !== undefined) {
                        lastMessage = formattedFecha + ' a las ' + formattedHora;
                    }
                    setLastMessage(lastMessage);
                    const diffTime = Math.ceil(Math.abs(dateLast - dateNow) / (1000));
                    //const emojiActive = diffTime <= 120 ? String.fromCodePoint(0x1f7e2) : String.fromCodePoint(0x1f534)
                    const emojiActive = (
                    <span
                        title={diffTime <= 120 ? "Active" : "Inactive"}
                        style={{
                        display: 'inline-block',
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        backgroundColor: diffTime <= 120 ? '#076129' : '#be0000',
                        }}
                        ></span>
                    );
                    setActive(emojiActive);
                    var timeValues = dataReceived.system.timeValues;
                    var tempValues = dataReceived.system.cpuTemp;
                    var cpuValues = dataReceived.system.cpu;
                    var memValues = dataReceived.system.memUsed;
                    var diskValues = dataReceived.system.diskUsed;
                    var responseValues = dataReceived.system.responseTime;
                    var vectorCpuTemp = [];
                    var vectorCpu = [];
                    var vectorMem = [];
                    var vectorDisk = [];
                    var vectorResponse = [];

                    for (var i = 0; i < dataReceived.system.timeValues.length; i++) {
                        var toPushCpuTemp = {
                            //"time": join(new Date(timeValues[i]), a, '-'),
                            "time": new Date(timeValues[i]).toLocaleTimeString('it-IT'),
                            "temp": tempValues[i]
                        }
                        var toPushCpu = {
                            "time": new Date(timeValues[i]).toLocaleTimeString('it-IT'),
                            "cpu": cpuValues[i]
                        }
                        var toPushMem = {
                            "time": new Date(timeValues[i]).toLocaleTimeString('it-IT'),
                            "mem": memValues[i]
                        }
                        var toPushDisk = {
                            "time": new Date(timeValues[i]).toLocaleTimeString('it-IT'),
                            "disk": diskValues[i]
                        }
                        if (dataReceived.system.timeValues.length === dataReceived.system.responseTime.length) {
                            var toPushResponse = {
                                "time": new Date(timeValues[i]).toLocaleTimeString('it-IT'),
                                "response": responseValues[i]
                            }
                            vectorResponse.push(toPushResponse);
                        }
                        vectorCpuTemp.push(toPushCpuTemp);
                        vectorCpu.push(toPushCpu);
                        vectorMem.push(toPushMem);
                        vectorDisk.push(toPushDisk);
                    }
                    await setTempStats(vectorCpuTemp);
                    await setCpuStats(vectorCpu);
                    await setMemStats(vectorMem);
                    await setDiskStats(vectorDisk);
                    await setResponseStats(vectorResponse);
                }

                else {
                    if (scale === 'Last Day') {
                        response = await fetch(url + '/historical/' + detectorID + '/lastDay', options).catch(err => {
                            console.log(err);
                        });
                        if (response.status !== 200) {
                            console.log("Can't get the detector historical information");
                        }
                    } else if (scale === 'Last Week') {
                        response = await fetch(url + '/historical/' + detectorID + '/lastWeek', options).catch(err => {
                            console.log(err);
                        });
                        if (response.status !== 200) {
                            console.log("Can't get the detector historical information");
                        }
                    } else if (scale === 'Last 15 Days') {
                        response = await fetch(url + '/historical/' + detectorID + '/last15days', options).catch(err => {
                            console.log(err);
                        });
                        if (response.status !== 200) {
                            console.log("Can't get the detector historical information");
                        }
                    }

                    var historicalData = await response.json();
                    var timeValues = historicalData.timeValues;
                    var tempValues = historicalData.cpuTemp;
                    var cpuValues = historicalData.cpu;
                    var memValues = historicalData.memUsed;
                    var diskValues = historicalData.diskUsed;
                    var responseValues = historicalData.responseTime ? historicalData.responseTime : [];
                    var vectorCpuTemp = [];
                    var vectorCpu = [];
                    var vectorMem = [];
                    var vectorDisk = [];
                    var vectorResponse = [];
                    for (var i = 0; i < historicalData.timeValues.length; i++) {
                        var time = '';

                        if (scale === 'Last 15 Days' || scale === 'Last Week') {
                            time = new Date(timeValues[i]).toLocaleString('en-GB')
                        } else {
                            time = new Date(timeValues[i]).toLocaleTimeString('it-IT')
                        }

                        var toPushCpuTemp = {
                            "time": time,
                            "temp": tempValues[i]
                        }
                        var toPushCpu = {
                            "time": time,
                            "cpu": cpuValues[i]
                        }
                        var toPushMem = {
                            "time": time,
                            "mem": memValues[i]
                        }
                        var toPushDisk = {
                            "time": time,
                            "disk": diskValues[i]
                        }
                        if (historicalData.timeValues.length == historicalData.responseTime.length) {
                            var toPushResponse = {
                                "time": time,
                                "response": responseValues[i]
                            }
                            vectorResponse.push(toPushResponse);
                        }
                        vectorCpuTemp.push(toPushCpuTemp);
                        vectorCpu.push(toPushCpu);
                        vectorMem.push(toPushMem);
                        vectorDisk.push(toPushDisk);
                    }
                    await setTempStats(vectorCpuTemp);
                    await setCpuStats(vectorCpu);
                    await setMemStats(vectorMem);
                    await setDiskStats(vectorDisk);
                    await setResponseStats(vectorResponse);
                }

                var actualTemp = dataReceived.system.cpuTemp[dataReceived.system.cpuTemp.length - 1];
                var actualCpu = dataReceived.system.cpu[dataReceived.system.cpu.length - 1];
                var actualDisk = dataReceived.system.diskUsed[dataReceived.system.diskUsed.length - 1];
                var actualMem = dataReceived.system.memUsed[dataReceived.system.memUsed.length - 1];


                setCpuTemp({
                    "title": "CPU Temperature",
                    "subtitle": "Current temperature of the CPU",
                    "actualValue": actualTemp,
                    "variant": actualTemp > thDataReceived.cpuTempTh ? "danger" : "success"
                });
                setCpu({
                    "title": "CPU Usage",
                    "subtitle": "Current percentage of the CPU used",
                    "actualValue": actualCpu,
                    "variant": actualCpu > thDataReceived.cpuTh ? "danger" : "success"
                });
                setMemUsed({
                    "title": "Memory Usage",
                    "subtitle": "Current percentage of the Memory used",
                    "actualValue": actualMem,
                    "variant": actualMem > thDataReceived.memTh ? "danger" : "success"
                });
                setDiskUsed({
                    "title": "Disk Usage",
                    "subtitle": "Current percentage of the Disk used",
                    "actualValue": actualDisk,
                    "variant": actualDisk > thDataReceived.diskTh ? "danger" : "success"
                });

                setChangedAlias(dataReceived.alias);
                if (dataReceived.network) {
                    if (dataReceived.network.length > 0 && dataReceived.network[0].name) {
                        networkRows = [];
                        dataReceived.network.forEach(network => {
                            var addresses = network.addresses;
                            var i = 0;
                            while (i < addresses.length) {
                                if (addresses.length > 1) {
                                    if (i == 0) {
                                        networkRows.push({
                                            name: network.name,
                                            addr: addresses[i],
                                            mac: network.mac,
                                            type: network.type
                                        })
                                    } else {
                                        networkRows.push({
                                            name: "",
                                            addr: addresses[i],
                                            mac: "",
                                            type: ""
                                        })
                                    }
                                } else {
                                    networkRows.push({
                                        name: network.name,
                                        addr: addresses[i],
                                        mac: network.mac,
                                        type: network.type
                                    })
                                }

                                i++;
                            }
                        });
                        setNetworkData(networkRows);

                    }
                }
                if (dataReceived.services) {
                    if (dataReceived.services.length > 0 && dataReceived.services[0].serviceName) {
                        servicesRows = [];
                        dataReceived.services.forEach(service => {
                            servicesRows.push({
                                name: service.serviceName,
                                enabled: service.enabled === true ? String.fromCodePoint(0x1f7e2) : String.fromCodePoint(0x1f534),
                                active: service.active === true ? String.fromCodePoint(0x1f7e2) : String.fromCodePoint(0x1f534),
                                type: service.type,
                                status: service.status
                            })
                        });
                        setServicesData(servicesRows);
                    }
                }

                if (dataReceived.relays) {
                    relaysRows = [];
                    if (dataReceived.relays.output.length > 0 && dataReceived.relays.output[0].alias) {
                        dataReceived.relays.output.forEach(output => {
                            relaysRows.push({
                                alias: output.alias,
                                inout: 'Output',
                                active: output.active === true ? String.fromCodePoint(0x1f7e2) : String.fromCodePoint(0x1f534),
                                enabled: output.enabled === true ? String.fromCodePoint(0x1f7e2) : String.fromCodePoint(0x1f534),
                            })
                        });
                    } if (dataReceived.relays.input.length > 0 && dataReceived.relays.input[0].alias) {
                        dataReceived.relays.input.forEach(input => {
                            relaysRows.push({
                                alias: input.alias,
                                inout: 'Input',
                                active: input.active === true ? String.fromCodePoint(0x1f7e2) : String.fromCodePoint(0x1f534),
                                enabled: input.enabled === true ? String.fromCodePoint(0x1f7e2) : String.fromCodePoint(0x1f534)
                            })
                        });
                    }
                    setRelaysData(relaysRows);
                }

                setLoading('hidden');

            }
        }
    }

    async function createTunnelConnection() {
        var tunnelsArray = detectorData.connections;
        const userLogged = localStorage.getItem("Login");
        tunnelsArray.forEach(async (tunnel) => {
            if (tunnel.tunnelLocalPort == tunnelPortCreated) {
                window.alert("The tunnel port " + tunnelPortCreated + " already exists!")
                return;
            }
        });
        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: JSON.stringify({
                "type": 'action',
                "ident": detectorID,
                "payload": {
                    "target": 'tunnel',
                    "action": 'create',
                    "params": tunnelPortCreated,
                    "user": userLogged,
                }
            })
        };

        if (detectorID !== "") {
            let response = await fetch(url + '/action', options).catch(err => {
                console.log(err);
            });
            if (response.status !== 200) {
                console.log("Can't create the tunnel");
            }
            var dataReceived = await response.json();
            console.log("Getting tunnel information" + dataReceived);
            console.log(dataReceived);
            validateDetector();
        }
    }

    async function deleteTunnelConnection(event) {
        const userLogged = localStorage.getItem("Login");
        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: JSON.stringify({
                "type": 'action',
                "ident": detectorID,
                "payload": {
                    "target": 'tunnel',
                    "action": 'delete',
                    "params": event.target.id,
                    "user": userLogged,
                }
            })
        };

        if (detectorID !== "") {
            let response = await fetch(url + '/action', options).catch(err => {
                console.log(err);
            });
            if (response.status !== 200) {
                console.log("Can't delete the tunnel");
            }
            var dataReceived = await response.json();
            console.log(dataReceived);
            validateDetector();
        }
    }

    function detectorInput(e) {
        var detectorIDs = localStorage.getItem("detectorIDs")
        detectorIDs = detectorIDs.split(',')
        const detector = e.target.value;
        var validation = false;

        detectorIDs.forEach(detID => {
            if (detID === detector) {
                validation = true;
            }
        });

        if (validation) {
            setDetectorBtnClass("success");
            setDetectorId(detector);
        } else {
            setDetectorBtnClass("primary");
            setDetectorId("");
        }

    }

    async function validateDetector() {
        if (detectorID !== "" && detectorID !== null) {
            localStorage.setItem("detSelected", detectorID);
            await computeDetectorsInformation();
        }
    }

    function handleTableClick(e) {
        if (e.target.innerHTML === "HTTP") {
            const newWindow = window.open('http://' + e.target.id, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        }
    }

    function changeNewTunnel(e) {
        setTunnelPortCreated(e.target.value);
    }

    function changeNewAlias(e) {
        setChangedAlias(e.target.value);
    }

    function changeNote(e) {
        setNewNote(e.target.value);
    }

    async function createNote() {
        const userLogged = localStorage.getItem("Login");
        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: JSON.stringify({
                "action": 'create',
                "user": userLogged,
                "note": newNote,
            })
        };

        if (detectorID !== "") {
            let response = await fetch(url + '/notes/' + detectorID, options).catch(err => {
                console.log(err);
            });
            if (response.status !== 200) {
                console.log("Can't create the note");
            }
        }
    }

    async function deleteNote(id) {
        const userLogged = localStorage.getItem("Login");
        if (userLogged == "admin@asdt.eu") {
            let options = {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*',
                    'Access-Control-Allow-Origin': '*',
                    'x-access-token': token
                },
                body: JSON.stringify({
                    "action": 'delete',
                    "user": userLogged,
                    "_id": id
                })
            };

            if (detectorID !== "") {
                let response = await fetch(url + '/notes/' + detectorID, options).catch(err => {
                    console.log(err);
                });
                if (response.status !== 200) {
                    console.log("Can't delete the note");
                } else {
                    window.alert('Note correctly deleted')
                }
            }
        } else {
            window.alert("You are not authorized to delte notes :(")
        }

    }

    function changeSub(e) {
        setNewSub(e.target.value);
    }

    async function addSub() {
        const userLogged = localStorage.getItem("Login");
        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: JSON.stringify({
                "action": 'add',
                "user": userLogged,
                "email": newSub,
            })
        };

        if (detectorID !== "") {
            let response = await fetch(url + '/subscriptor/' + detectorID, options).catch(err => {
                console.log(err);
            });
            if (response.status !== 200) {
                console.log("Can't add new subscriptor");
            }
        }
    }

    async function deleteSub(email) {
        const userLogged = localStorage.getItem("Login");
        if (userLogged == "admin@asdt.eu" || userLogged == "ldi@asdt.eu" || userLogged == "gm@asdt.eu") {
            let options = {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*',
                    'Access-Control-Allow-Origin': '*',
                    'x-access-token': token
                },
                body: JSON.stringify({
                    "action": 'delete',
                    "user": userLogged,
                    "email": email
                })
            };

            if (detectorID !== "") {
                let response = await fetch(url + '/subscriptor/' + detectorID, options).catch(err => {
                    console.log(err);
                });
                if (response.status !== 200) {
                    console.log("Can't delete the subscriptor");
                } else {
                    window.alert('Subscriptor correctly deleted')
                }
            }
        } else {
            window.alert("You are not authorized to delte subscriptors :(")
        }

    }

    async function startAutotest() {
        var tunnelsArray = detectorData.connections;
        const userLogged = localStorage.getItem("Login");

        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: JSON.stringify({
                "type": 'action',
                "ident": detectorID,
                "payload": {
                    "target": 'autotest',
                    "action": 'start',
                    "params": '',
                    "user": userLogged,
                }
            })
        };

        if (detectorID !== "") {
            let response = await fetch(url + '/action', options).catch(err => {
                console.log(err);
            });
            if (response.status !== 200) {
                console.log("Can't start the test");
            }
            var dataReceived = await response.json();
            //console.log("Getting tunnel information" + dataReceived);
            //console.log(dataReceived);
            validateDetector();
        }
    }

    async function powerOffDetector() {
        let popup = window.prompt("Are you sure to shut down: " + changedAlias + "?\nPlease, write down 'shutdown' to shut down the detector.")
        if (popup === null || popup === "") {
            window.alert('Operation Cancelled')
        } else if (popup === 'shutdown') {
            const userLogged = localStorage.getItem("Login");
            let options = {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*',
                    'Access-Control-Allow-Origin': '*',
                    'x-access-token': token
                },
                body: JSON.stringify({
                    "type": 'action',
                    "ident": detectorID,
                    "payload": {
                        "target": 'system',
                        "action": 'shutdown',
                        "params": '',
                        "user": userLogged,
                    }
                })
            };

            if (detectorID !== "") {
                let response = await fetch(url + '/action', options).catch(err => {
                    console.log(err);
                });
                if (response.status !== 200) {
                    console.log("Can't shut down the detector");
                }
                var dataReceived = await response.json();
                console.log(dataReceived);
                dataReceived.error ? window.alert(dataReceived.error) : window.alert("Detector OFF");
            }

        }

    }

    async function restartDetector() {
        var r = window.confirm("Do you really want to restart the detector?");
        if (r === true) {
            const userLogged = localStorage.getItem("Login");
            let options = {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*',
                    'Access-Control-Allow-Origin': '*', 'x-access-token': token
                },
                body: JSON.stringify({
                    "type": 'action',
                    "ident": detectorID,
                    "payload": {
                        "target": 'system',
                        "action": 'reboot',
                        "params": '',
                        "user": userLogged,
                    }
                })
            };

            if (detectorID !== "") {
                let response = await fetch(url + '/action', options).catch(err => {
                    console.log(err);
                });
                if (response.status !== 200) {
                    console.log("Can't restart the detector");
                }
                var dataReceived = await response.json();
                console.log(dataReceived);
                dataReceived.error ? window.alert(dataReceived.error) : window.alert("Detector Restarted");
            }
        }
    }

    async function createNewAlias() {
        const userLogged = localStorage.getItem("Login");
        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: JSON.stringify({
                "action": 'update',
                "ident": detectorID,
                "payload": {
                    "alias": changedAlias
                }
            })
        };

        if (detectorID !== "") {
            let response = await fetch(url + '/detector/' + detectorID, options).catch(err => {
                console.log(err);
            });
            if (response.status !== 200) {
                console.log("Can't update the detector alias");
            }
            var dataReceived = await response.json();
            console.log(dataReceived);
            let options_bis = {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*',
                    'Access-Control-Allow-Origin': '*',
                    'x-access-token': token
                },
                body: JSON.stringify({
                    "type": 'action',
                    "ident": detectorID,
                    "payload": {
                        "target": 'alias',
                        "action": "change",
                        "params": changedAlias,
                        "user": userLogged,
                    }
                })
            };
            let response_bis = await fetch(url + '/action', options_bis).catch(err => {
                console.log(err);
            });
            if (response_bis.status !== 200) {
                console.log("Can't change alias");
            }
            var dataReceived_bis = await response_bis.json();
            console.log(dataReceived_bis);

            history.push('/');
        }
    }

    async function deleteDetector() {
        var r = window.confirm("Do you really want to delete the detector?");
        if (r === true) {
            const userLogged = localStorage.getItem("Login");
            let options = {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*',
                    'Access-Control-Allow-Origin': '*',
                    'x-access-token': token
                },
                body: JSON.stringify({
                    "email": userLogged,
                    "ident": detectorID,
                })
            };
            if (detectorID !== "") {
                let response = await fetch(url + '/delete', options).catch(err => {
                    console.log(err);
                });
                if (response.status !== 200) {
                    console.log("Can't delete the detector");
                }
                var dataReceived = await response.json();
                console.log(dataReceived);
                //clearTimeout(timer);
                localStorage.setItem('detSelected', '')
                history.push('/');
            }
        }
    }

    async function actionOnService(name, action) {
        const userLogged = localStorage.getItem("Login");
        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: JSON.stringify({
                "type": 'action',
                "ident": detectorID,
                "payload": {
                    "target": 'service',
                    "action": action,
                    "params": name,
                    "user": userLogged,
                }
            })
        };

        if (detectorID !== "") {
            let response = await fetch(url + '/action', options).catch(err => {
                console.log(err);
            });
            if (response.status !== 200) {
                console.log("Can't " + action + " the service");
            }
            var dataReceived = await response.json();
            console.log(dataReceived);
        }
    }

    async function actionOnRelay(alias, action) {
        const userLogged = localStorage.getItem("Login");
        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: JSON.stringify({
                "type": 'action',
                "ident": detectorID,
                "payload": {
                    "target": 'relay',
                    "action": action,
                    "params": alias,
                    "user": userLogged,
                }
            })
        };

        if (detectorID !== "") {
            let response = await fetch(url + '/action', options).catch(err => {
                console.log(err);
            });
            if (response.status !== 200) {
                console.log("Can't " + action + " the relay");
            }
            var dataReceived = await response.json();
            console.log(dataReceived);
        }
    }

    const changeHandlerSys = (event) => {
        setSelectedFileSys(event.target.files[0]);
        setIsFilePickedSys(true);
    };

    const changeHandlerFs = (event) => {
        setSelectedFileFs(event.target.files[0]);
        setIsFilePickedFs(true);
    };

    async function updloadFirmware(event) {
        event.preventDefault();
        var data = new FormData();
        data.append("file", selectedFileFs);
        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: data
        };

        if (detectorID !== "") {
            let response = await fetch(url + '/firmware', options).catch(err => {
                console.log(err);
            });
            if (response.status !== 200) {
                window.alert("Can't post the new firmware.");
            } else {
                window.alert('Firmware FS uploaded correctly.')
            }
        }
        var data2 = new FormData();
        data2.append("file", selectedFileSys);
        let options2 = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: data2
        };

        if (detectorID !== "") {
            let response = await fetch(url + '/firmware', options2).catch(err => {
                console.log(err);
            });
            if (response.status !== 200) {
                window.alert("Can't post the new firmware.");
            } else {
                window.alert('Firmware SYS uploaded correctly.')
            }
        }
        getFirmwareInfo();
    }

    async function getFirmwareInfo() {
        let options = {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            }
        }
        let firmwareResponse = await fetch(url + '/firmware', options).catch(err => {
            console.log(err);
        });
        var firmwareDataReceived = await firmwareResponse.json();

        var data = [];

        await firmwareDataReceived.forEach(file => {
            var splitted = file.split('_');
            var versionfirmware = splitted[2].split('.');
            if (detectorID.includes(splitted[0])) {
                data.push({
                    "hardware": splitted[0],
                    "version": versionfirmware[0],
                });
            }
        });
        setFirmwareList(data);
    }

    async function updateDetector() {
        let popup = window.prompt("Are you sure to update: " + detectorID + " to version " + selOs + "?\nPlease, write down " + selOs + " to update the detector.")
        if (popup === null || popup === "") {
            window.alert('Operation Cancelled')
        } else if (popup === selOs) {
            const userLogged = localStorage.getItem("Login");
            let options = {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*',
                    'Access-Control-Allow-Origin': '*',
                    'x-access-token': token
                },
                body: JSON.stringify({
                    "type": 'action',
                    "ident": detectorID,
                    "payload": {
                        "target": 'system',
                        "action": 'update',
                        "params": selOs,
                        "user": userLogged,
                    }
                })
            };

            if (detectorID !== "") {
                let response = await fetch(url + '/action', options).catch(err => {
                    console.log(err);
                });
                if (response.status !== 200) {
                    console.log("Can't update the detector");
                }
                var dataReceived = await response.json();
                console.log(dataReceived);
                dataReceived.error ? window.alert(dataReceived.error) : window.alert("Updating detector ... ");
            }
            getFirmwareInfo();

        }
    }

    React.useEffect(() => {
        var timer = undefined;
        var timerLogs = undefined;
        async function fetchData() {
            timer = setTimeout(() => {
                fetchData();
            }, 7000);
            if (detectorSelected !== "" && detectorSelected !== null) {
                if (detectorData.ident === null || detectorData.ident === undefined) {
                    await setDetectorId(detectorSelected);
                    await validateDetector();
                }
            }
        }
        async function fetchLogs() {
            timerLogs = setTimeout(() => {
                fetchLogs();
            }, 20000);
            if (detectorSelected !== "" && detectorSelected !== null) {
                if (detectorData.ident === null || detectorData.ident === undefined) {
                    await getLogs();
                }
            }
        }
        fetchData();
        fetchLogs();
        getFirmwareInfo();
        return () => {
            clearTimeout(timer);
            clearTimeout(timerLogs);
            console.log("clearing timers..");
        }
    }
        , []);



    return (
        <div>
            <div className="title-box">
                <h1>Device</h1>
                <Form className="form-detector">
                    <Form.Row className="form-row-detector">
                        <Form.Group as={Row} controlId="formGridDetector">
                            <Form.Control defaultValue={detectorID} type="" placeholder="Enter serial number..." onChange={detectorInput} />
                        </Form.Group>
                        <Button variant={detectorBtnClass} id="detector-btn" className="detect-btn asdt-btn" style={{ backgroundColor: '#076129', borderColor: '#076129' }} onClick={validateDetector}>
                            Search
                        </Button>
                    </Form.Row>
                </Form>
            </div>
            <hr></hr>
            <br />
            <Tabs defaultActiveKey="dashboard" id="uncontrolled-tab-example" className="mb-3" style={{ fontColor: '#076129' }}>
                <Tab eventKey="dashboard" title="GENERAL" >
                    <br></br>
                    <div style={{ display: "flex", flexDirection: "column" }}>

                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <Card className="mb-5 " style={{ overflowX: 'scroll' , borderRadius: '20px'}}>
                                <Card.Body>
                                    <Card.Title><strong>GENERAL INFO</strong> &emsp;&emsp;&emsp;<small>CONNECTED: {active}</small></Card.Title>

                                    <br></br>
                                    <Table id="infoTable" >
                                        <thead></thead>
                                        <tbody>
                                            <tr>
                                                <th>IDENTIFIER:     </th>
                                                <td></td>
                                                <td>{detectorData.ident !== undefined ? detectorData.ident : "..."}</td>
                                            </tr>
                                            <tr><td></td></tr>

                                            <tr>
                                                <th>ALIAS:     </th>
                                                <td></td>
                                                <td>{detectorData.alias !== undefined ? detectorData.alias : "..."}</td>
                                            </tr>
                                            <tr><td></td></tr>
                                            <tr>
                                                <th>OS VERSION:     </th>
                                                <td></td>
                                                <td>{detectorData.osVersion !== undefined ? detectorData.osVersion : "..."}</td>
                                            </tr>
                                            <tr><td></td></tr>
                                            <tr>
                                                <th>PUBLIC IP:     </th>
                                                <td></td>
                                                <td>{detectorData.ipPublic !== undefined ? detectorData.ipPublic : "..."}</td>
                                            </tr>
                                            <tr><td></td></tr>
                                            <tr>
                                                <th>WAN INTERFACE:     </th>
                                                <td></td>
                                                <td>{detectorData.defaultIface ? detectorData.defaultIface : "..."}</td>
                                            </tr>
                                            <tr><td></td></tr>
                                            <tr>
                                                <th>LOCATION:     </th>
                                                <td>LAT</td>
                                                <td>{detectorData.location !== undefined ? detectorData.location.lat : "..."}</td>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <td>LON</td>
                                                <td>{detectorData.location !== undefined ? detectorData.location.lon : "..."}</td>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <td>ALT</td>
                                                <td>{detectorData.location !== undefined ? detectorData.location.alt + " m" : "..."}</td>
                                            </tr>
                                            <tr><td></td></tr>
                                            <tr>
                                                <th>LAST STATUS:     </th>
                                                <td></td>
                                                <td>{lastMessage !== "" ? lastMessage : "..."}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <Card className="mb-8 ml-5" style={{borderRadius: '20px'}}>
                                    <Card.Body>
                                        <Card.Title><strong>ACTIVE TUNNELS</strong></Card.Title>
                                        <br></br>

                                        <div style={{ overflowY: "scroll", maxHeight: "200px", marginBottom: "30px", textAlign: "center" }}>
                                            <Table striped hover responsive>
                                                <thead >
                                                    <tr>
                                                        <th>NAME</th>
                                                        <th>TYPE</th>
                                                        <th>PORT</th>
                                                        <th>LOCAL</th>
                                                        <th>REMOTE</th>
                                                        <th>STATE</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>

                                                <tbody style={{ overflowY: "scroll", height: "50px" }}>

                                                    {
                                                        detectorData.connections !== undefined ? detectorData.connections.map((item) => (

                                                            <tr key={item._id}>
                                                                <td>{item.tunnelName}</td>
                                                                <td><Button id={item.tunnelRemote + ":" + item.tunnelPort} onClick={handleTableClick} variant="outline-success" className="config-button" size="sm">{item.tunnelType}</Button></td>
                                                                <td>{item.tunnelPort}</td>
                                                                <td>{item.tunnelLocalPort}</td>
                                                                <td>{item.tunnelRemote}</td>
                                                                <td>{item.tunnelState === "CONNECTED" ? String.fromCodePoint(0x2705) : String.fromCodePoint(0x274c)}</td>
                                                                <td><Button variant="outline-light" id={item.tunnelPort} onClick={deleteTunnelConnection}><span className="center-trash" id={item.tunnelPort}>{String.fromCodePoint(0x1f5d1)}</span></Button></td>

                                                            </tr>
                                                        ))
                                                            : <tr key={1}>
                                                                <td>...</td>
                                                                <td>...</td>
                                                                <td>...</td>
                                                                <td>...</td>
                                                                <td>...</td>
                                                                <td>...</td>
                                                                <td>...</td>
                                                            </tr>}

                                                </tbody>
                                            </Table>
                                        </div>
                                    </Card.Body>
                                </Card>
                                {detectorPosition.lat !== 0 ? <MapWidget position={detectorPosition}></MapWidget> : <div></div>}
                            </div>

                        </div>
                        <div style={{ display: "flex", flexDirection: "row", marginBottom: '50px' }}>
                            <StatsWid data={cpuTemp} threshold={threshold.cpuTempTh} classdata="mr-4"></StatsWid>
                            <StatsWid data={cpu} threshold={threshold.cpuTh} classdata="mr-3 ml-3"></StatsWid>
                            <StatsWid data={diskUsed} threshold={threshold.diskTh} classdata="mr-3"></StatsWid>
                            <StatsWid data={memUsed} threshold={threshold.memTh} classdata="ml-3"></StatsWid>
                        </div>
                        <div style={{ flexDirection: "row", marginBottom: '50px', maxWidth: '1440px' }}>
                            <MaterialTable
                                title="LOGS"
                                data={logsData}
                                columns={logsColumns}
                                options={{ search: true, paging: true, headerStyle: { fontSize: '1em' }, pageSizeOptions: [10, 20, 30], pageSize: 10 }}
                                style={{ textAlign: 'center', borderRadius: '20px'}}
                            />
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="historical" title="STATS">
                    <LiveData setTimeScale={(id) => { setTimeScale(id) }} setLoading={setLoading} loading={loading} timeScale={timeScale} threshold={threshold} tempStats={tempStats} memStats={memStats} diskStats={diskStats} cpuStats={cpuStats} responseStats={responseStats}></LiveData>
                </Tab>
                <Tab eventKey="configuration" title="MANAGE">
                    <div style={{ display: "flex", flexDirection: "row", marginTop: '50px', marginBottom: '50px' }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <Card className="mb-5 mr-4" style={{ width: '500px', overflowX: 'scroll' , borderRadius: '20px'}}>
                                <Card.Body>
                                    <Card.Title><strong>Create Tunnel</strong></Card.Title>
                                    <br></br>
                                    <InputGroup className="mb-3">
                                        <FormControl
                                            placeholder="Tunnel Port"
                                            aria-label="Tunnel Port"
                                            aria-describedby="basic-addon2"
                                            onChange={changeNewTunnel}
                                        />
                                        <Button variant="outline-primary" id="button-addon2" onClick={createTunnelConnection}>
                                            Create
                                        </Button>
                                    </InputGroup>
                                </Card.Body>
                            </Card>
                            <Card className="mt-3 mb-4 mr-4" style={{ width: '500px', overflowX: 'scroll', borderRadius: '20px' }}>

                                <Card.Body>
                                    <Card.Title><strong>Change Alias</strong></Card.Title>
                                    <br></br>
                                    <InputGroup className="mb-3">
                                        <FormControl
                                            placeholder={changedAlias}
                                            aria-label="Alias"
                                            aria-describedby="basic-addon2"
                                            onChange={changeNewAlias}
                                        />
                                        <Button variant="outline-primary" id="button-addon2" onClick={createNewAlias}>
                                            Update
                                        </Button>
                                    </InputGroup>
                                </Card.Body>
                            </Card>
                        </div>
                        <Card className="mb-4 ml-4" style={{ overflowX: 'scroll', width: '500px' , borderRadius: '20px'}}>

                            <Card.Body>
                                <Card.Title>General Configuration</Card.Title>
                                <br></br>
                                <br></br>
                                <Table className="table-center">
                                    <thead></thead>
                                    <tbody>
                                        <tr>
                                            <td><Button size="lg" style={{color: "white", backgroundColor:'#c66f27', borderColor:'#c66f27'}} variant="danger" onClick={powerOffDetector}><span className="fas fa-power-off" aria-hidden="true"></span></Button></td>
                                            <td><Button size="lg" style={{color: "white", backgroundColor:'#076129', borderColor:'#076129'}} variant="info" onClick={restartDetector}><span className="fas fa-redo" aria-hidden="true"></span></Button></td>
                                            <td><Button size="lg" style={{color: "white", backgroundColor:'#be0000', borderColor:'#be0000'}} variant="warning" onClick={deleteDetector}><span className="far fa-trash-alt" aria-hidden="true"></span></Button></td>
                                        </tr>
                                        <tr>
                                            <td>Shut Down</td>
                                            <td>Restart</td>
                                            <td>Delete Detector</td>
                                        </tr>
                                        <tr><td></td></tr>
                                        <tr><td></td></tr>
                                        <tr>
                                            <td></td>
                                            <td>{autotestValue ? <Button size="lg" variant="success" onClick={startAutotest}><span className="fa fa-cog" aria-hidden="true"></span></Button> : ""}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td>{autotestValue ? "Auto-Test" : ""}</td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>

                    </div>
                    <div style={{ display: "flex", flexDirection: "row", marginBottom: '30px' }}>
                        <MaterialTable
                            title="Network details"
                            data={networkData}
                            columns={networkColumns}
                            options={{ search: true, paging: true, headerStyle: { fontSize: '1em', paddingLeft: '40px' } }}
                            style={{ textAlign: 'center', width: '1050px', borderRadius: '20px' }}
                            localization={
                                {
                                    header: {
                                        actions: ""
                                    }
                                }
                            }
                            actions={[
                            ]}
                        />
                    </div>
                    <div style={{ display: "flex", flexDirection: "row", marginBottom: '30px' }}>
                        <MaterialTable
                            title="Relays details"
                            data={relaysData}
                            columns={relaysColumns}
                            options={{ search: true, paging: true, headerStyle: { fontSize: '1em', paddingLeft: '40px' } }}
                            style={{ textAlign: 'center', width: '1050px' , borderRadius: '20px'}}
                            localization={
                                {
                                    header: {
                                        actions: ""
                                    }
                                }
                            }
                            actions={[
                                {
                                    icon: 'flash_on',
                                    tooltip: 'Enable Relay',
                                    iconProps: { color: 'action' },
                                    onClick: (event, rowData) => {
                                        if (rowData.enabled == String.fromCodePoint(0x1f7e2)) {
                                            actionOnRelay(rowData.alias, 'enable');
                                        } else {
                                            window.alert("You can't enable an inactive relay.")
                                        }

                                    }
                                },
                                {
                                    icon: 'disabled_by_default',
                                    tooltip: 'Disable Relay',
                                    iconProps: { color: 'action' },
                                    onClick: (event, rowData) => {
                                        if (rowData.enabled == String.fromCodePoint(0x1f7e2)) {
                                            actionOnRelay(rowData.alias, 'disable');
                                        } else {
                                            window.alert("You can't disable an inactive relay.")
                                        }
                                    }
                                },
                                {
                                    icon: 'power_off',
                                    tooltip: 'Shut Down Relay',
                                    iconProps: { color: 'action' },
                                    onClick: (event, rowData) => {
                                        if (rowData.enabled == String.fromCodePoint(0x1f7e2)) {
                                            actionOnRelay(rowData.alias, 'shutdown');
                                        } else {
                                            window.alert("You can't shutdown an inactive relay.")
                                        }
                                    }
                                },
                            ]}
                        />
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <MaterialTable
                            title="Services details"
                            data={servicesData}
                            columns={servicesColumns}
                            options={{ search: true, paging: true, headerStyle: { fontSize: '1em', paddingLeft: '40px' } }}
                            style={{ textAlign: 'center', width: '1050px' , borderRadius: '20px'}}
                            localization={
                                {
                                    header: {
                                        actions: ""
                                    }
                                }
                            }
                            actions={[
                                {
                                    icon: 'play_arrow',
                                    tooltip: 'Start Service',
                                    iconProps: { color: 'action' },
                                    onClick: (event, rowData) => {
                                        actionOnService(rowData.name, 'start');
                                    }
                                },
                                {
                                    icon: 'stop',
                                    iconProps: { color: 'secondary' },
                                    tooltip: 'Stop Service',
                                    onClick: (event, rowData) => {
                                        actionOnService(rowData.name, 'stop');
                                    }
                                },
                                {
                                    icon: 'restart_alt',
                                    tooltip: 'Restart Service',
                                    onClick: (event, rowData) => {
                                        actionOnService(rowData.name, 'restart');
                                    }
                                },
                                {
                                    icon: 'flash_on',
                                    iconProps: { color: 'primary' },
                                    tooltip: 'Enable Service',
                                    onClick: (event, rowData) => {
                                        actionOnService(rowData.name, 'enable');
                                    }
                                },
                                {
                                    icon: 'disabled_by_default',
                                    iconProps: { color: 'error' },
                                    tooltip: 'Disable Service',
                                    onClick: (event, rowData) => {
                                        actionOnService(rowData.name, 'disable');
                                    }
                                }
                            ]}
                        />
                    </div>

                </Tab>
                <Tab eventKey="notes" title="NOTES">
                    <div style={{ display: "flex", flexDirection: "row", alignItems: 'flex-start', marginTop: '50px', marginBottom: '50px' }}>
                        <Card className="mb-4 mr-4" style={{ overflowX: 'scroll', width: '500px' , borderRadius: '20px'}}>
                            <Card.Body>
                                <Card.Title><strong>New Note</strong></Card.Title>
                                <br></br>
                                <InputGroup className="mb-3">
                                    <FormControl
                                        as="textarea"
                                        rows={5}
                                        aria-describedby="basic-addon2"
                                        onChange={changeNote}
                                    />
                                </InputGroup>
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
                                    <Button variant="outline-primary" id="button-addon2" onClick={createNote}>
                                        Create
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                        <Card className="mb-4 mr-4" style={{ display: 'flex', width: '700px', overflowX: 'scroll' , borderRadius: '20px'}}>
                            <Card.Body>
                                <Card.Title><strong>Notes</strong></Card.Title>
                                <br></br>
                                <MaterialTable
                                    title="Notes"
                                    data={noteList}
                                    columns={notesColumns}
                                    options={{ search: true, paging: true, padding: 'dense', actionsColumnIndex: -1, headerStyle: { fontSize: '1em', paddingLeft: '40px' } }}
                                    style={{ textAlign: 'center' }}
                                    localization={
                                        {
                                            header: {
                                                actions: ""
                                            }
                                        }
                                    }
                                    actions={[
                                        {
                                            icon: 'delete',
                                            tooltip: 'Delete Note',
                                            iconProps: { color: 'action' },
                                            onClick: (event, rowData) => {
                                                deleteNote(rowData.id);
                                            }
                                        }
                                    ]}
                                />
                            </Card.Body>
                        </Card>
                    </div>
                </Tab>
                {/* <Tab eventKey="subs" title="Subscriptors">
                    <div style={{ display: "flex", flexDirection: "row", alignItems: 'flex-start', marginTop: '50px', marginBottom: '50px' }}>
                        <Card className="mb-4 mr-4" style={{ overflowX: 'scroll', width: '500px' }}>
                            <Card.Body>
                                <Card.Title><strong>New Subscriptor</strong></Card.Title>
                                <br></br>
                                <InputGroup className="mb-3">
                                    <FormControl
                                        placeholder="User Email"
                                        aria-label="User Email"
                                        aria-describedby="basic-addon2"
                                        onChange={changeSub}
                                    />
                                    <Button variant="outline-primary" id="button-addon2" onClick={addSub}>
                                        Add
                                    </Button>
                                </InputGroup>
                            </Card.Body>
                        </Card>
                        <Card className="mb-4 mr-4" style={{ display: 'flex', width: '700px', overflowX: 'scroll' }}>
                            <Card.Body>
                                <Card.Title><strong>Subscriptors</strong></Card.Title>
                                <br></br>
                                <MaterialTable
                                    title="Subscriptors"
                                    data={subList}
                                    columns={subColumns}
                                    options={{ search: true, paging: true, padding: 'dense', actionsColumnIndex: -1, headerStyle: { fontSize: '1em', paddingLeft: '40px' } }}
                                    style={{ textAlign: 'center' }}
                                    localization={
                                        {
                                            header: {
                                                actions: ""
                                            }
                                        }
                                    }
                                    actions={[
                                        {
                                            icon: 'delete',
                                            tooltip: 'Delete Subscriptor',
                                            iconProps: { color: 'action' },
                                            onClick: (event, rowData) => {
                                                deleteSub(rowData.email);
                                            }
                                        }
                                    ]}
                                />
                            </Card.Body>
                        </Card>
                    </div>
                </Tab> */}
                <Tab eventKey="firmware" title="FIRMWARE">
                    <div style={{ display: "flex", flexDirection: "row", alignItems: 'flex-start', marginTop: '50px', marginBottom: '50px' }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <Card className="mb-4 mr-4" style={{ overflowX: 'scroll', width: '500px' , borderRadius: '20px'}}>
                                <Card.Body>
                                    <Card.Title><strong>New Firmware</strong></Card.Title>
                                    <br></br>
                                    <Form.Group controlId="formFile" className="mb-3">
                                        <Form.Label>SYS File</Form.Label>
                                        <Form.Control type="file" onChange={changeHandlerSys} />
                                    </Form.Group>
                                    <Form.Group controlId="formFile" className="mb-3">
                                        <Form.Label>FS File</Form.Label>
                                        <Form.Control type="file" onChange={changeHandlerFs} />
                                    </Form.Group>
                                    {isFilePickedFs && isFilePickedSys ?
                                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
                                            <Button variant="outline-primary" id="button-addon2" onClick={updloadFirmware}>
                                                Upload Firmware
                                            </Button>
                                        </div>
                                        : null}
                                </Card.Body>
                            </Card>
                            <MaterialTable
                                title="Versions"
                                data={firmwareList}
                                columns={firmwareColumns}
                                options={{ search: true, paging: true, pageSize: 5, headerStyle: { fontSize: '1em', paddingLeft: '40px' } }}
                                style={{ textAlign: 'center' , borderRadius: '20px'}}
                                localization={
                                    {
                                        header: {
                                            actions: ""
                                        }
                                    }
                                }
                                actions={[{
                                    icon: 'info',
                                    tooltip: 'Select Detector',
                                    iconProps: { color: 'action' },
                                    onClick: (event, rowData) => {
                                        //localStorage.setItem("detSelected", rowData.version);
                                        setSelOs(rowData.version);
                                    }
                                },
                                ]}
                            />
                        </div>
                        <Card className="mb-4 mr-4" style={{ overflowX: 'scroll', width: '500px' , borderRadius: '20px'}}>
                            <Card.Body>
                                <Card.Title><strong>New Update</strong></Card.Title>
                                <br></br>
                                <br></br>

                                <InputGroup className="mb-3">
                                    <InputGroup.Text id="basic-addon1">Parameters</InputGroup.Text>
                                    <FormControl placeholder="Introduce update parameters ..."
                                        value={selOs}
                                        aria-label="user"
                                        aria-describedby="basic-addon1"
                                        onChange={(e) => setSelOs(e.target.value)}></FormControl>
                                </InputGroup>
                                <br></br>
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                    <Button variant="primary" id="button-addon2" style={{ backgroundColor: '#2137b9', borderColor: '#2137b9' }} onClick={updateDetector}>
                                        Update
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </Tab>
            </Tabs>
        </div>
    );
}


export default Detector;
